// Stripe price ids for the pricing page, from build-time settings.
//
// The backend accepts only the six ids in its own STRIPE_*_PRICE_* settings, and uses
// them as lookup keys for a plan and interval, not as the price it charges. Staging runs
// on a Stripe sandbox account with its own ids; production on the live account. So each
// build must carry the ids of the backend it is built for.
//
// Like REACT_APP_SERVER_URL, these are compiled into the bundle. The deploy workflow
// supplies them per environment from GitHub Actions repository variables
// (STAGING_STRIPE_* / PROD_STRIPE_*), local development reads .env.development, and
// scripts/require-env.js refuses to build without them. Price ids are not secrets: they
// are sent to the browser on every checkout.
const STRIPE_PRICES = {
  STANDARD_MONTHLY: process.env.REACT_APP_STRIPE_STANDARD_PRICE_MONTHLY,
  STANDARD_YEARLY: process.env.REACT_APP_STRIPE_STANDARD_PRICE_YEARLY,
  PREMIUM_MONTHLY: process.env.REACT_APP_STRIPE_PREMIUM_PRICE_MONTHLY,
  PREMIUM_YEARLY: process.env.REACT_APP_STRIPE_PREMIUM_PRICE_YEARLY,
  POWER_MONTHLY: process.env.REACT_APP_STRIPE_POWER_PRICE_MONTHLY,
  POWER_YEARLY: process.env.REACT_APP_STRIPE_POWER_PRICE_YEARLY,
};

export default STRIPE_PRICES;
